var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adBox"},[(_vm.imgurl)?_c('img',{staticClass:"url_img",attrs:{"src":_vm.imgurl,"alt":"广告位"},on:{"click":_vm.btn_img}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }